// Identical file in Reader & NL-CMS. If you modify this file, make the same changes there,
// and vice-versa, unless changes should be specific to this project, then remove this comment.
import axios from 'axios';

const axiosInstance = axios.create();

export default async function request(
  verb: string,
  endpoint: string,
  params = {},
  isFormData = false
) {
  let data = {};
  if (verb === 'get') {
    // if request is get, params grabbed from query string;
    data = { params: { ...params } }; // GET
  } else if (verb === 'delete') {
    // if request is delete, data key is used
    data = { data: { ...params } }; // DELETE
  } else if (isFormData) {
    data = params;
  } else {
    // otherwise, we don't need params or data key
    data = { ...params }; // POST, PATCH, PUT;
  }

  // add CSRF token if it's on the page
  const tokenElement: HTMLMetaElement | null = document.querySelector('[name=csrf-token]');
  const token = tokenElement?.content;
  axiosInstance.defaults.headers.common['X-CSRF-TOKEN'] = token;
  axiosInstance.defaults.headers.common['Accept'] = 'application/json';

  const req = axiosInstance[verb](endpoint, data);

  try {
    return (await req).data;
  } catch (err) {
    const message = err.response.data.message;
    throw Array.isArray(message) ? message : [message];
  }
}
